/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_EmptyInputs */

const en_us2_exercise_empty = /** @type {(inputs: Exercise_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No exercises match these filters.`)
};

const pt_br2_exercise_empty = /** @type {(inputs: Exercise_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício com esses filtros.`)
};

const es_419_exercise_empty = /** @type {(inputs: Exercise_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún ejercicio coincide con estos filtros.`)
};

const pt_pt2_exercise_empty = /** @type {(inputs: Exercise_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum exercício com estes filtros.`)
};

const fr_fr2_exercise_empty = /** @type {(inputs: Exercise_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun exercice ne correspond à ces filtres.`)
};

const de_de2_exercise_empty = /** @type {(inputs: Exercise_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Übungen passen zu diesen Filtern.`)
};

const it_it2_exercise_empty = /** @type {(inputs: Exercise_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun esercizio con questi filtri.`)
};

/**
* | output |
* | --- |
* | "No exercises match these filters." |
*
* @param {Exercise_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_empty = /** @type {((inputs?: Exercise_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_empty(inputs)
	if (locale === "es-419") return es_419_exercise_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_empty(inputs)
	if (locale === "de-DE") return de_de2_exercise_empty(inputs)
	if (locale === "it-IT") return it_it2_exercise_empty(inputs)
	return en_us2_exercise_empty(inputs)
});
export { exercise_empty as "exercise.empty" }